import { useSelector } from "react-redux";
import { hasPermission, checkIsAdmin, PermissionId, ObjectTarget, } from "../../../app/permissions";
import { selectUser } from "../../../redux/user/userSlice";
import FragmentCardContent from "../../../features/base/FragmentCardContent";
import { getImagesUrl } from "../../../redux/common";
import { ConversationListContainer } from "../../../features/conversation/ConversationListContainer";
import { SchoolInfo } from "../../../redux/school/schoolSlice";
import { MessagesScreen } from "../../../features/conversation/messages/MessagesScreen";
import { useEffect, useMemo } from "react";
import { retrieveConversationList, RetrieveConversationListRequest, selectConversationList } from "../../../redux/conversation/conversationListSlice";
import { useAppDispatch } from "../../../app/hooks";
import { Box, Stack } from "@mui/material";
import { getElementHeight } from "../../../app/utils";
import { NamedObject } from "../../../redux/object/namedObject";

interface SchoolMessagesProps {
    school: SchoolInfo;
}

export const SchoolMessages = (props: SchoolMessagesProps) => {
    const dispatch = useAppDispatch();
    const user = useSelector(selectUser);
    const conversationList = useSelector(selectConversationList);

    const isAdmin = useMemo(() => checkIsAdmin(user.priza.info), [user.priza.info]);
    const me = useMemo((): NamedObject => {
        return NamedObject.school(props.school);
    }, [props.school]);
    const hasMessages = useMemo(
        () => isAdmin ||
            hasPermission(user.priza.info, PermissionId.SCHOOL_ADMIN, props.school.id) ||
            hasPermission(user.priza.info, PermissionId.SCHOOL_MESSAGE, props.school.id),
        [user.priza.info, props.school.id]);

    useEffect(() => {
        if (hasMessages) {
            const request: RetrieveConversationListRequest = {
                objectTarget: ObjectTarget.SCHOOL,
                targetId: `${props.school.id}`,
            };
            dispatch(retrieveConversationList(request));
        }
    }, [hasMessages, conversationList, user, props.school.id]);


    if (!hasMessages) {
        return <FragmentCardContent
            image={`${getImagesUrl()}/forbidden.webp`}
            title="Messagens"
            description="Sem permissões para enviar mensagem por esta escola."
        />;
    }

    const topHeight = getElementHeight("top-bar");
    const appNameHeight = getElementHeight("app-name");
    const appControlHeight = getElementHeight("app-control");
    const messageHeight = window.innerHeight - (2 + topHeight + appNameHeight + appControlHeight);

    return <Stack direction="row" spacing={0}>
        <Box id='contacts' sx={{ width: "400px", minWidth: "400px", maxWidth: "400px" }}>
            <ConversationListContainer
                me={me}
                school={props.school}
                height={messageHeight}
            />
        </Box>
        <Box id='conversation' sx={{ width: "100%" }}>
            <MessagesScreen height={messageHeight} 
                // me={me} 
                // schoolId={props.school.id}
            />
        </Box>
    </Stack>;

};

